import React from "react";

function SvgLinkedin(props) {
    return (
        <svg viewBox="0 0 495 495" height="5vh" {...props}>
            <path fill="#fff" d="M247.5 0v40H455v415H247.5v40H495V0z" />
            <path fill="#fff" d="M40 455V40h207.5V0H0v495h247.5v-40z" />
            <path
                d="M127.323 167.186h.446c23.551 0 38.194-15.601 38.194-35.101-.442-19.928-14.643-35.087-37.752-35.087-23.104 0-38.211 15.159-38.211 35.087 0 19.5 14.678 35.101 37.323 35.101zM266.4 398.002V284.576c0-6.086.464-12.119 2.24-16.459 4.887-12.149 15.978-24.693 34.641-24.693 24.439 0 34.195 18.629 34.195 45.92v108.657H405V281.535c0-62.379-33.307-91.398-77.744-91.398-35.871 0-51.883 19.74-60.856 33.547v.665h-.442c.118-.219.306-.442.442-.665v-28.779h-67.537c.905 19.053 0 203.096 0 203.096H266.4zM94.016 194.906h67.506v203.096H94.016z"
                fill="#fff"
            />
        </svg>
    );
}

export default SvgLinkedin;



// WEBPACK FOOTER //
// ./src/images/svg/SvgLinkedin.jsx